import React from "react";
import styled from "styled-components";
import {IdeaPortfolioUpdateOutcome} from "./IdeaPortfolioUpdateOutcome";
import {PartialUpdateWarning} from "./PartialUpdateWarning";
import successIcon from "../../../../images/icon-check-circle.svg";

const Container = styled.div`
    display: flex;
    flex-shrink: 0;
`;

const SuccessIcon = styled.img`
    width: 29px;
    height: 29px;
    margin-right: 33px;
    margin-left: 6px;
`;

const OutcomesContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const Spacer = styled.div`
    margin-top: 12px;
`;

export const SuccessfulOutcomes = ({succeed, requestedPercentage, className}) => {
    if (!succeed || succeed.length === 0) return null;

    return <Container className={className}>
        <SuccessIcon src={successIcon}/>
        <OutcomesContainer>
            {
                succeed.map((outcome, index) => {
                    return <React.Fragment key={outcome.portfolioId}>
                        {index === 0 ? null : <Spacer/>}
                        <IdeaPortfolioUpdateOutcome outcome={outcome}/>
                        {outcome.status === "partial" ? <PartialUpdateWarning actualPercentage={outcome.investmentPercentChange} requestedPercentage={requestedPercentage}/> : null}
                    </React.Fragment>;
                })
            }
        </OutcomesContainer>
    </Container>;
};